import router from "./index"
window.routerArr = []
window.routerHash = {}
const oldPushFunc = router.push
const oldReplaceFunc = router.replace
const oldGoFunc = router.go

router.push = params => {
  return oldPushFunc.call(router, params).then(() => {
    const currentRouteName = router.history.current.name
    window.routerArr.push(currentRouteName)
  })
}
router.replace = params => {
  return oldReplaceFunc.call(router, params).then(() => {
    let lastIndex = window.routerArr.length - 1
    lastIndex < 0 && (lastIndex = 0)
    const currentRouteName = router.history.current.name
    window.routerArr[lastIndex] = currentRouteName
  })
}
router.go = params => {
  oldGoFunc.call(router, params)
  window.routerArr.splice(params)
}
router.afterEach(to => {
  const toName = to.name
  const backRouteName = window.routerArr.slice(-2, -1)[0] || {}
  const isBack = toName === backRouteName
  if (isBack) {
    window.routerArr.pop()
  }
})
